import React, { useEffect } from "react";
import ReduxProviders from "@/store/store-provider";
import "@/globals.css";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { ConfirmationProvider } from "@/components/common/ConfirmationDialog";
import { GlobalLoading } from "@/components/common/GlobalLoading";
import { WonderPushLoader } from "@/components/WonderPushLoader";

export function AppLayout({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    document.title = "Shiphouse Seller Admin";

    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute("content", "Shiphouse Seller Admin Panel");
  }, []);

  return (
    <ConfirmationProvider>
      <ReduxProviders>
        <ThemeProvider>
          <WonderPushLoader />
          {/* <p>Test </p> */}
          {children}
          <GlobalLoading />
        </ThemeProvider>
      </ReduxProviders>
    </ConfirmationProvider>
  );
}
